module.exports = __webpack_public_path__ + "static/media/Left legs03.a84987e5.png";